/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ofType, StateObservable } from "redux-observable";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { IAppState } from "../types";
import { DataProvider } from "../../providers";
import { IErrorModel } from "../../models";
import * as Actions from "./actions";
import * as Consts from "./consts";
import * as Types from "./types";

const getOffersEpic = (
  action$: Observable<Types.IGetOffersAction>,
  state$: StateObservable<IAppState>
) =>
  action$.pipe(
    ofType(Consts.GET_OFFERS),
    switchMap(async () => {
      try {
        const offers = await DataProvider.getOffers({
          UtmCampaign: state$.value.auth.user?.UtmCampaign,
        });
        return Actions.getOffersSuccess(offers);
      } catch (error) {
        return Actions.getOffersFailure(error as IErrorModel);
      }
    })
  );

export const paymentsEpics = [getOffersEpic];
